import { useNavigate, useParams } from "react-router-dom";
import CardHeader from "../../../antd/components/CardHeader";
import * as yup from 'yup';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
//import { Collapse, InputGroup } from "react-bootstrap";
import { useContext, useState } from "react";
import CurrencyInput from 'react-currency-input-field';
import './styles.css';
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { CreateProjectAPI } from "../../../API/ProjectsAPI";
import { AuthContext } from "../../../Contexts/AuthContext";
import { AllStatus } from "../../../Utils/AllContratTypes";
import { Select } from "antd";
import { ISelectProps } from "../../../Interfaces/ISelectProps";
import TextField from "@mui/material/TextField";
import { Button } from 'antd';
import { Collapse, DatePicker, Form, Input, message, Space, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { InputGroup } from "react-bootstrap";
import 'dayjs/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';

interface FormSubmitProps {
    projectName: string;
    activities: string;
}

const CreateProject = () => {
    const { id, type, opportunityId } = useParams();
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const [equipmentValue, setEquipmentValue] = useState<string>("0");
    const [contractTypeText, setContractTypeText] = useState<string>("");
    const [inProgress, setInProgress] = useState<boolean>(false);

    const navigate = useNavigate();
    const [form] = Form.useForm();

    const schema = yup.object().shape({
        projectName: yup.string().required("Por favor, insira um nome ao projeto!"),
        activities: yup.string().required("Por favor, insira uma atividade!"),
    });

    const { register, handleSubmit, formState: { errors } } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

   

    const Submit = async () => {
        try {
            toggleLoading(true);
            debugger;
            const data = form.getFieldsValue();
            let projectName = data.projectName ?? "";
            let activities = data.activities ?? "";
            let budget = data.budget == "" || data.budget == undefined ? 0 : data.budget.replace(",", ".");
            let startDate = data.startDate ? data.startDate.format('DD/MM/YYYY') : null;
            let endDate = data.endDate ? data.endDate.format('DD/MM/YYYY') : null;
            let objective = data.objective ?? "";
            let contractCET = data.contractCET;
            let expectedExpenses = data.expectedExpenses ?? "";
            let valuesApplied = data.valuesApplied ?? false;
            let humanResources = data.humanResources == "" || data.humanResources == undefined ? 0 : data.humanResources.replace(",", ".");
            let infraValue = data.infrastructureValue == "" || data.infrastructureValue == undefined ? 0 : data.infrastructureValue.replace(",", ".");
            let invoicesValue = data.invoiceValue == "" || data.invoiceValue == undefined ? 0 : data.invoiceValue.replace(",", ".");
            let others = data.othersValue == "" || data.othersValue == undefined ? 0 : data.othersValue.replace(",", ".");

            await CreateProjectAPI(id ?? "", opportunityId ?? "", userEmail, projectName, activities, startDate, endDate, parseInt(type ?? "0"), budget, humanResources, equipmentValue, invoicesValue, infraValue,
                contractTypeText, inProgress, objective, contractCET, expectedExpenses, valuesApplied, others).then((resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        toast.success(`Projeto ${projectName} criado com sucesso!`);
                        navigate(`/projectInformation/${id}`);
                    }
                }).finally(() => {
                    toggleLoading(false);
                });
        }
        catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Novo Projeto"}
                hasPageBefore={true}
                linkPageBefore={`/projectInformation/${id}`}
                pageBeforeName={"Informações de Projetos"}
            />
            <div className='card-body mt-2 ps-4 pe-2'>
                <Form form={form} layout="vertical">
                    <div className='d-flex align-items-center row'>
                        <div className="col-md-6">
                            <Form.Item className="w-100 me-3"
                                name="projectName"
                                rules={[{ required: true }]}
                                label="Nome do Projeto:">
                                <Input className='form-control mt-2'
                                    placeholder=" Nome do Projeto.."
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="startDate" label=" Data de Previsão de Inicio" className=" w-100 mt-1">
                                <DatePicker locale={locale} style={{ width: '100%', height: '40px' }} format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="endDate" label="Data de Previsão de Termino" className=" w-100 mt-1">
                                <DatePicker
                                    locale={locale}
                                    style={{ width: '100%', height: '40px' }}
                                    format={"DD/MM/YYYY"}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Form.Item name="objective"
                                label="Objetivo"
                                required
                                className="mt-2 mb-2">
                                <TextArea rows={5}
                                    className="form-control mt-2"
                                />
                            </Form.Item>
                        </div>
                        <div className="col">
                            <Form.Item name="activities"
                                label="Atividades Associadas ao Projeto:"
                                required
                                className="mt-2 mb-2">
                                <TextArea rows={5}
                                    className="form-control mt-2"
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className='d-flex align-items-center row'>
                        <div className=" col-md-12 mb-3">
                            <label>Tem contrato com ICTs?</label>
                            <Form.Item
                                name="contractCET"
                                rules={[{ required: true, message: 'Por favor, selecione uma opção!' }]}>

                                <Select
                                    style={{ width: ' 100%', height: '40px' }}
                                    options={[{ value: false, label: 'Não' },
                                    { value: true, label: "Sim" }
                                    ]}
                                />
                            </Form.Item>
                        </div>

                    </div>
                    <div className="mb-4 ">
                        <Collapse
                            items={[{
                                key: '1', label: 'Orçamento Estimado do Projeto:', children: <div id="collapse" className='p-1'>
                                    <div className='row '>
                                        <div className="col-12 mx-0">
                                            <Form.Item label="Gastos esperados" name="expectedExpenses">

                                                <Input
                                                    style={{ height: "40px" }}
                                                    className="form-control"
                                                    placeholder="Gastos esperados..."
                                                // onChange={(e) => {
                                                //     setBudget(e.target.value);
                                                //     form.setFieldsValue({ expectedExpenses: e.target.value }); // Atualiza o Form.Item
                                                // }}
                                                // onBlur={setZeroForAll}
                                                />

                                            </Form.Item>

                                        </div>
                                    </div>
                                    <div className=' row'>
                                        <div className=" col-md-6">
                                            <label>Há valores já Aplicados ao projeto?</label>
                                            <Form.Item
                                                name="valuesApplied">
                                                <Select
                                                    style={{ width: ' 100%', height: '40px' }}
                                                    options={[
                                                        { value: false, label: 'Não' },
                                                        { value: true, label: 'Sim' }
                                                    ]}
                                                />
                                            </Form.Item>


                                        </div>
                                        <div className=" col-md-6 ">
                                            <label>Orçamento estimado do projeto</label>
                                            <Form.Item className=' w-100'
                                                name="budget">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="buget"
                                                    className='form-control'
                                                    placeholder="R$ 0,00"

                                                />
                                            </Form.Item>

                                        </div>
                                    </div>

                                </div>
                            }]}
                        />
                    </div>
                    <div className="mb-4 ">
                        <Collapse
                            items={[{
                                key: '1', label: 'Rubricas por Projeto:', children: <div id="collapse" className='p-1'>

                                    <div className='row p-b-2'>
                                        <div className=" col-md-3">
                                            <label>Recursos Humanos: </label>
                                            <Form.Item
                                                name="humanResources">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="buget"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>


                                        </div>

                                        <div className=" col-md-3">
                                            <label>Infraestrutura</label>
                                            <Form.Item className=' w-100'
                                                name="infrastructureValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="infrastructureValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                        <div className=" col-md-3">
                                            <label>Serviços de Terceiro</label>
                                            <Form.Item className=' w-100'
                                                name="invoiceValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="invoiceValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                        <div className=" col-md-3">
                                            <label>Outros</label>
                                            <Form.Item className=' w-100'
                                                name="othersValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="othersValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                    </div>

                                </div>
                            }]}
                        />
                    </div>
                    <div className="d-flex justify-content-end align-items-center mb-4">

                        <Button size="large" type="primary" onClick={Submit} className="font-weight-bold" > Salvar Projeto</Button>
                    </div>
                    {/* <Button variant="contained" type='button' className='btn btn-primary mb-3 mt-4'>

                    </Button> */}
                </Form>
            </div>
        </div>
    )
}

export default CreateProject;

